import React from 'react';
import { Clock } from 'lucide-react';
import SectionHeading from './SectionHeading';
import { formatPublishNp } from '../../utils/timeAgo';

function LatestNews({ items = [], onOpen, title = 'ताजा समाचार', limit = 5 }) {
  const safe = Array.isArray(items) ? items : [];
  const list = safe.slice(0, limit);
  if (list.length === 0) return null;

  return (
    <div className="bg-white border border-line rounded-[14px] p-5 min-w-0">
      <SectionHeading title={title} />
      <div className="flex flex-col divide-y divide-line">
        {list.map((n, idx) => (
          <article
            key={n.id}
            className="group flex gap-3 py-3 cursor-pointer first:pt-2"
            onClick={() => onOpen(n)}
            role="button"
            tabIndex={0}
          >
            <span
              className="font-display text-[20px] font-bold w-7 flex-shrink-0 leading-none select-none"
              style={{ color: 'transparent', WebkitTextStroke: '1.3px var(--crimson)' }}
            >
              {String(idx + 1).padStart(2, '0')}
            </span>
            <div className="min-w-0 flex-1">
              <h4 className="text-[14.5px] font-semibold leading-snug transition-colors group-hover:text-blue line-clamp-2">
                {n.title}
              </h4>
              <span className="flex items-center gap-1 text-xs text-muted mt-1">
                <Clock size={11} /> {formatPublishNp(n.created_at || n.date)}
              </span>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

export default LatestNews;